import React from 'react'
import "../css/Patientdashboard.css"
import { useState, useEffect, useRef } from 'react'
import { Routes, Route, useNavigate, useLocation, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { APIConstants, CommonAPIConstants } from '../utilities/Constants'

const Notes = () => {

  const [notes, setNotes] = useState('');

  const navigate = useNavigate()


  const userData = useSelector((state) => state.user.user);

  const dispatch = useDispatch();



  const { id } = useParams();
  const PatientID = localStorage.setItem("PatientID", id);



  var userPracticeID = userData ? userData.practiceID : null;

  var userId = userData ? userData.userID : null;


  const sAuthToken = useSelector((state) => state.user.user.sAuthToken);

  //console.log("Appointment ID>>>>>>>>>>>>>", id);

  const DemoGraphyData = useSelector((state) => state.user.demoDetails);

  
    const getNotes = async () => {
  
      const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientNotes}?sInputJSON={"PracticeID":${userPracticeID},"PatientID":${id}}`;
  
      fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sAuthToken}`
        }
      })
  
        .then((response) => {
          if (response.status != 200) { console.log("response.status", response.status); }
          else return response.json();
        })
  
        .then((res) => {
  
          const parseData = JSON.parse(res)
          setNotes(parseData?.Data.SharedNotes1[0]?.notes)
          console.log("Notes Data>>>>>>", parseData);
  
        })
        .catch((err) => {
          console.error("Error occurred while fetching location", {
            autoClose: 3000,
          });
        });
    };
  


  const debounceNotestTimeout = useRef(null);

  const saveNotes = async () => {

  
    if (debounceNotestTimeout.current) {
      clearTimeout(debounceNotestTimeout.current);
    }


    debounceNotestTimeout.current = setTimeout(async () => {

      const InputJson = JSON.stringify(JSON.stringify({
        PatientID: id,
        PracticeID: userPracticeID,
        IsShared: 1,
        Notes: notes,
        noteText: notes,
        UserID: userPracticeID,
      }));


      try {

      
          const response = await fetch(APIConstants.PATIENT_PORTAL_URL + CommonAPIConstants.SavePatientNotes, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${sAuthToken}`
            },
            body: InputJson
          });

          const data = await response.json();


        

        // toast.success("Notes Updated Successfully");
      } catch (error) {
        console.error("Error saving notes:", error);

      }

    }, 500)
  };


  
  
    useEffect(() => {
      getNotes()
     
  
    }, [notes])

  return (
    <>
      <div style={{ padding: '20px' }}>
        <textarea
          className="notes-textarea"
          placeholder="Enter your notes here..."
          Value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
      </div>

      <button className="save-notes" onClick={saveNotes}>Save Notes</button>
    </>
  )
}

export default Notes